(function() {

    var accordionTrigger = '.js-accordion-trigger';
    var $accordionTrigger = $(accordionTrigger);
    var accordionContent = '.js-accordion-content';
    var $accordionContent = $(accordionContent);
    var accordionIcon = '.js-accordion-icon';
    var $accordionIcon = $(accordionIcon);
    var accordion = '.js-accordion';
    var $accordion = $(accordion);
    var expandedAccordionOnLoad = '.js-accordion--expanded-on-load';
    var $expandedAccordionOnLoad = $(expandedAccordionOnLoad);
    var manuallyTriggeredAccordionsArr = [];

    //	======================================================================  //
    //	Parameters
    //	======================================================================  //

    /**
     * NOTE: breakpoint-based behavior change occurs with the addition of a
     * `no-accordion-breakpoint` data-attribute in the HTML.
     */

    var params = {
        toggleSpeed: 233,
        htmlIcon: false,
        hiddenIconClass: 'is-hidden',
        bgIconPointingUpClass: 'is-triggered'
    };

    //	======================================================================  //
    //	Functions
    //	======================================================================  //

    /**
     * @function `responsiveAccordions`
     *
     * Extends the `params` @var with additional settings, depending on the
     * presence of a `data-attribute`
     */
    function responsiveAccordions() {
        var behaviorBreakpoint = $accordion.data('no-accordion-breakpoint');
        if( behaviorBreakpoint ) {
            $.extend(params, {
                responsiveAccordions: true,
                responsive: {
                    noAccordionBreakpoint: behaviorBreakpoint
                }
            });
        }
        else {
            $.extend(params, {
                responsiveAccordions: false
            });
        }
    }

    /**
     * @function `closeAccordions`
     *
     * Closes all accordions on the page, if any.
     *
     * 1. Quick escape if no accordions on the page.
     * 2. If the key is not found in @var `params`, run the function.
     * 3. In the case of responsive accordions, if the viewport width is greater
     *    than the "no accordion" breakpoint, keep the accordions open. That quick
     *    escape is useful when the function is called on load.
     */
    function closeAccordions() {
        if(!$accordion.length) { /* [1] */
            return;
        }
        if(!('responsiveAccordions' in params)) { /* [2] */
            responsiveAccordions();
        }
        if(params.responsiveAccordions &&
            _window_width >= params.responsive.noAccordionBreakpoint ) { /* [3] */
            return;
        }
        var exclusion = '';
        for(var i = 0, exclLength = manuallyTriggeredAccordionsArr.length;
        i < exclLength; i++) {
            exclusion += (i > 0) ? ', ' : '';
            exclusion += ':eq('+manuallyTriggeredAccordionsArr[i]+')';
        }
        if(params.htmlIcon) {
            $accordion.not(expandedAccordionOnLoad).not(exclusion)
                .find(accordionTrigger).removeClass(params.hiddenIconClass);
        }
        else {
            $accordion.not(expandedAccordionOnLoad).not(exclusion)
                .find(accordionTrigger)
                .removeClass(params.bgIconPointingUpClass);
            $expandedAccordionOnLoad.find(accordionTrigger)
                .addClass(params.bgIconPointingUpClass);
        }
        $accordion.not(expandedAccordionOnLoad).not(exclusion)
            .find(accordionContent).hide();
    }

    /**
     * @function `openAccordions`
     *
     * Opens all the accordions (no animation).
     */
    function openAccordions() {
        $accordionTrigger.addClass(params.bgIconPointingUpClass);
        $accordionContent.show();
    }

    /**
     * @function `toggleContent`
     *
     * Toggles content visible/hidden (related to trigger).
     *
     * @param $trigger (node) - the related trigger.
     *
     * 1. Remove from array.
     */
    function toggleContent( $trigger ) {
        var $relatedAccordion = $trigger.closest(accordion);
        var $content = $relatedAccordion.find(accordionContent);
        var index = $accordion.index($relatedAccordion);
        if( $content.is(':visible') ) {
            $content.slideUp(params.toggleSpeed);
            manuallyTriggeredAccordionsArr =
            $.grep(manuallyTriggeredAccordionsArr, function(value) { /* [1] */
                return value != index;
            });
        }
        else {
            $content.slideDown(params.toggleSpeed);
            manuallyTriggeredAccordionsArr.push(index);
        }
    }

    /**
     * @function `toggleIcon`
     *
     * Toggles trigger icon status.
     *
     * 1. Case for an HTML icon: class is applied to the icon.
     * 2. Case for a CSS icon: class is applied to the trigger.
     */
    function toggleIcon( $trigger ) {
        var $icons = $trigger.find(accordionIcon);
        if (params.htmlIcon) { /* [1] */
            $icons.toggleClass(params.hiddenIconClass);
        }
        else { /* [2] */
            $trigger.toggleClass(params.bgIconPointingUpClass);
        }
    }

    /**
     * @function `accordionsOrNot`
     *
     * Changes accordion state depending on viewport width.
     *
     * 1. Quick escape if no responsive behavior required.
     * 2. Above "no accordion" breakpoint, open them all (content is
     *    always visible).
     * 3. Below breakpoint, accordion behavior (starts with the closed state).
     */
    function accordionsOrNot() {
        if(!params.responsiveAccordions) { /* [1] */
            return;
        }
        if( _window_width >= params.responsive.noAccordionBreakpoint ) { /* [2] */
            openAccordions();
        }
        else { /* [3] */
            closeAccordions();
        }
    }

    //	======================================================================  //
    //	On ready
    //	======================================================================  //

    onReady.callbacks.accordions = function() {
        closeAccordions();
    };

    //	======================================================================  //
    //	On resize
    //	======================================================================  //

    onResize.callbacks.accordions = function() {
        accordionsOrNot();
    };

    //	======================================================================  //
    //	On click
    //	======================================================================  //

    /**
     * 1. If a responsive behavior is required and above the "no accordion"
     *    breakpoint, don't do anything when clicking on the trigger.
     */
    _$document.on('click', accordionTrigger, function(e) {
        e.preventDefault();
        if(params.responsiveAccordions &&
            _window_width >= params.responsive.noAccordionBreakpoint) { /* [1] */
            return;
        }
        toggleContent( $(this) );
        toggleIcon( $(this) );
    });

})();
